<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white shadow-sm">
    <div class="container">
      <router-link class="navbar-brand" to="/home">MAX'Bx 電力監測系統 <span v-show="is_dev"> - 工程版</span></router-link>
      <!-- Right Side Of Navbar -->
      <!-- <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a id="navbarDropdown" class="nav-link dropdown-toggle" role="button" data-toggle="dropdown">
            {{ name }}
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <button class="dropdown-item" v-on:click="switchRegion(region)" v-for="region, index in userRegions"
              :key="index" v-show="region.meters && Object.keys(region.meters).length > 0">
              {{ region.name }}
            </button>

            <button class="dropdown-item" v-on:click="userLogOut">
              Logout
            </button>
          </div>
        </li>
      </ul> -->

    </div>
  </nav>
</template>

<script>
import { axiosMixins } from '../mixins/axiosErrorMessage';

export default {
  props: ['userRegions', 'userInfo'],
  mixins: [axiosMixins],
  data() {
    return {
      base_url,
      isChangeNameFormVisible: false,
      is_dev: false,
    };
  },
  mounted() {
    process.env.NODE_ENV !== "production" ? this.is_dev = true : this.is_dev = false;
  },
  methods: {
    userLogOut() {
      axios.get(base_url + "/api/logout")
        .then((response) => {
          localStorage.removeItem('token');
          localStorage.removeItem('user_info');
          this.$store.commit('setLoginCurrentContent', 'login');
          this.$router.push({ name: "login" });
        }).catch(error => this.axiosMessage(error));
    },
    switchRegion(region) {
      this.$emit('switch-region', region, region.meters[0].bx_mac);
    }
  }
}
</script>

<style></style>
